import { Badge, Button, Col, Row } from "antd";

import React, { useEffect, useState } from "react";
import useIsDesktop from "../utils/hooks/useIsDesktop";
import Typography from "../components/Typography";
import { COLORS } from "../constants/Colors";
import SearchCardWithFilter from "../components/SearchCardWithFilter";
import ShipmentList from "../components/ParkingList";
import { instance } from "../components/AxiosClient";
import GetProfile from "../components/VariableStore";
import { useDebounce } from "../utils/hooks/useDebounce";
import _ from "lodash";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import FilterTracking from "../components/FilterTracking";
import moment from "moment";
import {
  errorNotification,
  successNotification,
} from "../components/Notification";
import { useIsMoblie, useIsTablet } from "../utils/hooks/useMobile";
import {
  getQueueListApi,
  getQueueuList,
} from "../controllers/home/CardHomeAPI";
import ParkingList from "../components/ParkingList";
import SearchQueueCardWithFilter from "../components/queue/SearchCardWithFilter";
import FilterQueue from "../components/queue/FilterQueue";
import QueueList from "../components/queue/QueueList";
import CardTopHome from "../components/home/CardTop";
import CreateQueueModal from "../components/queue/modal/createQueue";
import ModalAddProduct from "../components/queue/modal/addProduct";
import ConfirmChagneQueue from "../components/queue/modal/confirm";
import ConfirmCreateQueue from "../components/queue/modal/confirm_create";

const QueueParking = () => {
  const intl = useIntl();
  const isDesktop = useIsDesktop();
  const isMobile = useIsMoblie();
  const state = useSelector((state) => state);
  const [queueSearch, setQueueSearch] = useState();
  const [pagination, setPagination] = useState(1);
  const [size, setSize] = useState(10);
  const [total, setTotal] = useState();
  const useDebounceSearch = useDebounce(queueSearch, 500);
  const parsLocal = JSON.parse(localStorage.getItem("persist:loop_store"));
  const customerData = JSON.parse(parsLocal.customerProfileReducer);
  const [event, setEvent] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [filterDot, setFilterDot] = useState(false);
  const [shipmentStatus, setShipmentStatus] = useState([]);
  const [queueuFilter, setQueueFilter] = useState({
    queueStatus: undefined,
    fromCreateDateIn: undefined,
    toCreateDateIn: undefined,
    fromCreateDateOut: undefined,
    toCreateDateOut: undefined,
    parking: undefined,
  });

  const [searchTable, setSearchTable] = useState({
    order: undefined,
    field: undefined,
    page: 1,
    size: 10,
  });

  const [queueList, setQueueList] = useState([]);
  const [queueVisible, setQueueVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [recordQueue, setRecordQueue] = useState([]);
  const [itemCate, setitemCate] = useState([]);
  const [visibleChange, setVisibleChange] = useState(false);

  const comCode = GetProfile("customerCode") || _.get(customerData, "comCode");
  const customerId =
    GetProfile("customerId") || _.get(customerData, "customerId");

  console.log("tablesearch", searchTable);

  console.log("sreach", queueSearch, queueuFilter);

  useEffect(() => {
    const getQueueList = async () => {
      const filterStatus = _.filter(shipmentStatus, (item) => {
        return item.statusFlowCode === _.get(queueuFilter, "queueStatus");
      });

      const body = {
        fromDate: _.get(queueuFilter, "fromCreateDateOut")
          ? moment(new Date(_.get(queueuFilter, "fromCreateDateOut"))).format(
              "YYYY-MM-DD"
            )
          : undefined,
        toDate: _.get(queueuFilter, "toCreateDateOut")
          ? moment(new Date(_.get(queueuFilter, "toCreateDateOut"))).format(
              "YYYY-MM-DD"
            )
          : undefined,
        pageNumber: pagination,
        limit: size,
        queueNumber: "asc",
        createdBy: customerId,
        // orderStatus: _.get(filterStatus,'statusCode'),
        orderTypeCode: ["SELF-DO", "TAS-DO"],

        serialNoCarlot: _.get(queueuFilter, "parking"),
        customerName: _.get(queueuFilter, "customerName"),
        orderStatus: _.get(queueuFilter, "queueStatus")
          ? _.get(filterStatus, "[0].statusCode")
          : undefined,
        // createdAtFrom
        // createdAtTo
        queueNo: queueSearch,
      };

      try {
        const response = await getQueueListApi(body);
        // setQueueList(response.data.docs);
        setQueueList(_.get(response, "data.list"));
        setTotal(response.data.orderCount);

        const defaultType = ["SELF-DO", "TAS-DO"];
        // const typeInfo = _.filter(_.get(response, 'data.mapviewDeliveryOrderStatus'), (item) => _.includes(defaultType, item.orderTypeCode))
        const typeInfo = _.get(response, "data.mapviewDeliveryOrderStatus");
        setShipmentStatus(typeInfo);
      } catch (error) {}
    };
    getQueueList();
  }, [event, queueSearch, pagination,size]);

  // const getOrdersList = async () => {
  //   const search = {
  //     "contact.customerContactName": _.get(queueuFilter, "customerName")
  //       ? _.get(queueuFilter, "customerName")
  //       : undefined,
  //     "contact.customerContactPhone": _.get(queueuFilter, "customerPhone")
  //       ? _.get(queueuFilter, "customerPhone")
  //       : undefined,
  //     "customer.comtomerName": undefined,
  //     "destination.address": "",
  //     orderNo: queueSearch,
  //     sizesizeName: "",
  //     sourceaddress: "",
  //     weightTxt: "",
  //     fromCreateDate: _.get(queueuFilter, "fromCreateDate")
  //       ? moment(new Date(_.get(queueuFilter, "fromCreateDate"))).format(
  //           "YYYY-MM-DD"
  //         )
  //       : "",
  //     toCreateDate: _.get(queueuFilter, "toCreateDate")
  //       ? moment(new Date(_.get(queueuFilter, "toCreateDate"))).format(
  //           "YYYY-MM-DD"
  //         )
  //       : "",
  //     orderStatus: _.get(queueuFilter, "orderStatus")
  //       ? _.get(queueuFilter, "orderStatus")
  //       : "",
  //   };

  //   const body = {
  //     search: search,
  //     "customer.customerId": customerId,
  //     pageNumber: queueSearch ? 1 : pagination,
  //     limit: 10,
  //   };

  //   try {
  //     const response = await instance.post(
  //       `/v5/order/manager/company/${comCode}/web/deliveryorder/report/loopmerchant`,
  //       body
  //     );
  //     setShipmentData(response.data.data.list);
  //     setTotal(response.data.data.allRows);
  //     setShipmentStatus(response.data.data.statusList);
  //   } catch (error) {
  //     return error.response.data;
  //   }
  // };

  const handleSerchShipment = (values) => {
    setQueueSearch(values);
  };

  const handleFilterShipment = (values, key) => {
    // console.log('orderStatus',moment(new Date(values)).format('YYYY-MM-DD'),'/key:',values);
    if (values === "" || values === undefined || values === null) {
      setFilterDot(false);
    } else {
      setFilterDot(true);
    }

    setQueueFilter((prev) => ({ ...prev, [key]: values }));
  };

  // const handleFilterShipmentDate = (values) => {
  //   console.log('SSorderStatus',moment(values));
  //   if (values === '' || values === undefined || values === null) {
  //     setFilterDot(false)
  //   }else{
  //     setFilterDot(true)
  //   }
  //   setQueueFilter((prev) => ({ ...prev, [key]: values }));
  // };

  const handleChange = (pagination, sorter, extra) => {
    console.log("tablechange", pagination, "sorter:", sorter, "extra:", extra);
    let field = extra.field;
    if (extra.order) {
      if (extra.order === "descend") {
        setSearchTable((prev) => ({ ...prev, order: "desc" }));
      } else {
        if (extra.order === "descend") {
          setSearchTable((prev) => ({ ...prev, order: "asc" }));
        }
      }
    } else {
      setSearchTable((prev) => ({ ...prev, order: undefined }));
    }

    setSearchTable((prev) => ({
      ...prev,
      field: field,
      page: pagination.current,
      size: pagination.pageSize,
    }));
    // searchShipment.setShipmentField(field);
    // searchShipment.setShipmentPage(pagination.current);
    // searchShipment.setShipmentSize(pagination.pageSize);
  };

  const handleChangePage = (value,size) => {
    console.log("PPOPO", value);

    setPagination(value);
    setSize(size);
  };

  const handleChangeSize = (value) => {
    console.log('SIISISI',value);
    
    setSize(parseInt(value));
  };

  const handleApply = () => {
    setEvent((prev) => !prev);
    setPagination(1);
  };

  const handleReset = () => {
    setQueueFilter({
      customerName: "",
      customerPhone: "",
      orderStatus: undefined,
      fromCreateDate: undefined,
      toCreateDate: undefined,
      parking: "",
    });
    setFilterDot(false);
    setEvent((prev) => !prev);
    setPagination(1);
  };

  const onToggleFilter = () => {
    setFilterVisible((prev) => !prev);
  };

  const exportOrdersList = async () => {
    const filterStatus = _.filter(shipmentStatus, (item) => {
      return item.statusFlowCode === _.get(queueuFilter, "queueStatus");
    });
    const Lang = localStorage.getItem("lang");
    const temp = Lang === "TH" ? "statusMapView.txt.TH" : "statusMapView.txt.EN";

    const body = {
      fromDate: _.get(queueuFilter, "fromCreateDateOut")
        ? moment(new Date(_.get(queueuFilter, "fromCreateDateOut"))).format(
            "YYYY-MM-DD"
          )
        : undefined,
      toDate: _.get(queueuFilter, "toCreateDateOut")
        ? moment(new Date(_.get(queueuFilter, "toCreateDateOut"))).format(
            "YYYY-MM-DD"
          )
        : undefined,
      pageNumber: 1,
      limit: total,
      queueNumber: "asc",
      createdBy: customerId,
      orderStatus: [],
      orderTypeCode: ["SELF-DO", "TAS-DO"],

      serialNoCarlot: _.get(queueuFilter, "parking"),
      customerName: _.get(queueuFilter, "customerName"),
      orderStatus: _.get(queueuFilter, "queueStatus")
        ? _.get(filterStatus, "[0].statusCode")
        : undefined,
      // createdAtFrom
      // createdAtTo
      queueNo: queueSearch,
      viewFormat: [
        {
          colName: intl.formatMessage({
            id: "queueColumnsDeliveryQueue",
            defaultMessage: "Delivery Queue",
          }),
          sequence: 1,
          colCode: "queueNo",
        },
        {
          colName: intl.formatMessage({
            id: "queueColumnsLotNo",
            defaultMessage: "Lot No.",
          }),
          sequence: 2,
          colCode: "serialNoCarlot",
        },
        {
          colName: intl.formatMessage({
            id: "queueColumnsContainerNo",
            defaultMessage: "Container No.",
          }),
          sequence: 3,
          colCode: "assetNameCarlot",
        },
        {
          colName: intl.formatMessage({
            id: "queueColumnsVendorOrCustomerName",
            defaultMessage: "Vendor or Customer Name",
          }),
          sequence: 4,
          colCode: "vendorAndCustomer",
        },
        {
          colName: intl.formatMessage({
            id: "queueColumnsItem",
            defaultMessage: "Item",
          }),
          sequence: 5,
          colCode: "parcel",
        },
        {
          colName: intl.formatMessage({
            id: "queueColumnsWaitingTime",
            defaultMessage: "Waiting Time (minute)",
          }),
          sequence: 6,
          colCode: "waitingMinutes",
        },
        {
          colName: intl.formatMessage({
            id: "queueColumnsStatus",
            defaultMessage: "Status",
          }),
          sequence: 7,
          colCode: temp,
        },
        {
          colName: intl.formatMessage({
            id: "queueColumnsDeliveryDate",
            defaultMessage: "Delivery Date",
          }),
          sequence: 8,
          colCode: "completedAtDate",
        },
        {
          colName: intl.formatMessage({
            id: "queueColumnsDeliveryTime",
            defaultMessage: "Delivery Time",
          }),
          sequence: 9,
          colCode: "completedAtTime",
        },
        {
          colName: intl.formatMessage({
            id: "queueColumnsCreateDate",
            defaultMessage: "Create Date",
          }),
          sequence: 10,
          colCode: "confirmedAtDate",
        },
        {
          colName: intl.formatMessage({
            id: "queueColumnsCreateTime",
            defaultMessage: "Create Time",
          }),
          sequence: 11,
          colCode: "confirmedAtTime",
        },
      ],
    };

    try {
      const response = await instance.post(
        `/v5/order/manager/company/${comCode}/web/deliveryorder/reportexportv2`,
        body
      );

      if (response.status === 200) {
        window.open(_.get(response, "data.data.data.url"));
        successNotification(response.data.status.message);
      } else {
        errorNotification(response.data.status.message);
      }
    } catch (error) {
      return error.response.data;
    }
  };

  const openCreateQueue = () => {
    setQueueVisible(true);
    setVisibleView(false);
    setRecordQueue([]);
  };

  const closeCreateQueue = () => {
    setQueueVisible(false);
  };

  const openViewQueue = (record) => {
    setQueueVisible(true);
    setVisibleView(true);
  };

  const closeViewQueue = () => {
    setQueueVisible(false);
    setVisibleView(false);
  };

  const onClickView = (value) => {
    setRecordQueue(value);
  };

  const openChangeQueue = (record) => {
    setVisibleChange(true);
  };

  return (
    <div className="d-flex flex-column w-100 h-100 p-3 justify-content-between">
      <div style={{ marginBottom: "10px" }}>
        <Row gutter={isMobile ? [16, 24] : [16, 16]}>
          <Col span={24}>
            <CardTopHome type={"queue"} menu={"queue"} setitemCate={setitemCate}  />
          </Col>
          <Col span={24}>
            <SearchQueueCardWithFilter
              handleSerchShipment={handleSerchShipment}
              onToggleFilter={onToggleFilter}
              filterDot={filterDot}
              openCreateQueue={openCreateQueue}
            />
            <div style={{ display: filterVisible ? undefined : "none" }}>
              <FilterQueue
                handleFilterShipment={handleFilterShipment}
                shipmentStatus={shipmentStatus}
                handleApply={handleApply}
                handleReset={handleReset}
                queueuFilter={queueuFilter}
              />
            </div>
          </Col>

          <Col span={24}>
            {/* test */}
            <QueueList
              queueData={queueList}
              total={total}
              handleChangePage={handleChangePage}
              setEvent={setEvent}
              exportOrdersList={exportOrdersList}
              isDesktop={isDesktop}
              openViewQueue={openViewQueue}
              onClickView={onClickView}
              pagination={pagination}
              size={size}
              handleChangeSize={handleChangeSize}
              openChangeQueue={openChangeQueue}
              recordQueue={recordQueue}
            />
          </Col>
        </Row>
      </div>
      {!isDesktop && (
        <div
          className={`d-flex align-items-center ${
            isDesktop ? "justify-content-start" : "justify-content-center"
          } px-4`}
          style={{
            height: 46,
            backgroundColor: COLORS.Primary,
            padding: "24px",
            width: "100vw",
            marginLeft: "-16px",
            // marginTop: "16px",
            marginBottom: "-16px",
          }}
        >
          <Typography size="12.5px" color={COLORS.White}>
            Powered by © RAPIDTECH Co., Ltd. (V 1.0)
          </Typography>
        </div>
      )}
      <CreateQueueModal
        isOpen={queueVisible}
        onCancle={closeCreateQueue}
        setTrigger={setEvent}
        isView={visibleView}
        recordQueue={recordQueue}
        isEdit={_.size(recordQueue) > 0}
        itemCate={itemCate}
      />
    </div>
  );
};

export default QueueParking;
